import { Copy } from "@phosphor-icons/react";
import { Flex, IconButton, Text, Box, useClipboard } from "@chakra-ui/react";
import { copyToClipboard } from "../../../utils/text-utils";

const NonEditTextArea = ({ children, copyable = true, copyContent, ...props }) => {
  const onCopy = async () => {
    copyToClipboard(copyContent || children);
  }

  return (
    <Flex
      align="center"
      borderColor="borderGrey"
      borderWidth="1px"
      p={2}
      borderRadius="md"
      bg="pureWhite"
      color="gray.500"
      {...props}
    >
      <Box flex="1" whiteSpace="pre-wrap">
        {children}
      </Box>
      {copyable && (
        <IconButton aria-label="Copy to clipboard" icon={<Copy />} size="s" onClick={onCopy} variant="ghost" />
      )}
    </Flex>
  );
};

export default NonEditTextArea;
